function getBranchData() {
  const BRANCH_TYPE_CHOICE = {
    1: "pf",
    2: "pj",
    3: "mei",
  };

  let currentBranch = window.localStorage.getItem(
    "easygestorweb_current_branch"
  );

  if (currentBranch) {
    currentBranch = JSON.parse(currentBranch);
    currentBranch.branch_type = BRANCH_TYPE_CHOICE[currentBranch.branch_type];
    return currentBranch;
  } else {
    return {};
  }
}

export default function checkNFCeConfig() {
  getInvoiceType();
}
export const getInvoiceType = () => {
  let branch = getBranchData();

  if (branch.is_fiscal) {

    if (branch.fiscal_config.nfce_csc_token && branch.fiscal_config.nfce_id_csc) {

      return 2

    }
  }

  if (branch.crt !== 4) {
    if (!branch.certificate) {
      window.location.href = "/digital-certificate/?from=/pos-without-certificate";
    }
    if (branch.is_fiscal) {
      if (!branch.fiscal_config.nfce_csc_token) {
        window.location.href = "/nfce/settings/?from=/pos";
      }
    }
    return 2
  } else {
    return undefined;
  }

  // const branchPlan = branch.branch_plan
  // if (branchPlan.notes_quantity === 0) {
  //     return 1
  // }
  // if (branch.crt_description === "mei") {
  //     if (branchPlan.notes_quantity > 0) {
  //         return 1
  //     }

  // } else {
  //     if (branchPlan.notes_quantity > 1) {

  //         let allowNfce = false

  //         if (branch.fiscal_config){
  //             allowNfce = branch.is_fiscal && branch.fiscal_config.nfce_csc_token
  //         }

  //         if (!allowNfce) {
  //             window.location.href = "/nfce/settings/?from=/pos"
  //         }
  //         return 2
  //     }
  // }
};



// WEBPACK FOOTER //
// ./src/views/AppViews/POS/checkNFCeConfig.js